export default __webpack_public_path__ + "static/media/activeCheck.c2985d7b.svg";